import { useEffect } from "react";

import ResizeObserver from "resize-observer-polyfill";

import { POST_MESSAGE_ID } from "../constants/EmbedForm";

export const useHTMLResizePostMessage = (element?: HTMLElement) => {
  useEffect(() => {
    const update = function (height: number) {
      parent.postMessage(
        {
          id: POST_MESSAGE_ID,
          height,
        },
        "*"
      );
    };

    const resizeObserver = new ResizeObserver((entries) => {
      update(entries[0].contentRect.height);
    });
    resizeObserver.observe(element || (document.querySelector("html") as HTMLHtmlElement));

    return () => {
      resizeObserver.disconnect();
    };
  }, [element]);
};
